<div [formGroup]="form" class="payer-wrapper form-col-8">
  <np-inv-type-radio-group [formControlName]="controlName"
                           [types]="types">
  </np-inv-type-radio-group>
  <ng-container [ngSwitch]="form.get(controlName).value">
    <app-delivery-third-person *ngSwitchCase="'ThirdPerson'"
                               [form]="form"></app-delivery-third-person>
  </ng-container>
</div>
